function calculateDPI(assetPxWidth: number, assetPxHeight: number, imageMmWidth: number, imageMmHeight: number) {
  return Math.round(Math.min(assetPxWidth / (imageMmWidth / 25.4), assetPxHeight / (imageMmHeight / 25.4)));
}

export function calculateMm(sizePx: number, dpi: number) {
  return (sizePx * 25.4) / dpi;
}

export default calculateDPI;
